import DHowRegister from './DHowRegister'

export default DHowRegister
